const KEY = "qs_quality_cache";
const QUEUE = "qs_quality_rating_queue";
const DEVICE = "qs_device_id";

export const deviceId = () => {
  let id = localStorage.getItem(DEVICE);
  if (!id) { id = `dev-${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`; localStorage.setItem(DEVICE, id); }
  return id;
};

export const readCache = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export const cachePassport = (b, via) => {
  const rows = readCache().filter((x) => x.id !== b.id);
  rows.unshift({ ...b, cached_at: new Date().toISOString(), via });
  localStorage.setItem(KEY, JSON.stringify(rows.slice(0, 20)));
};

export const cachedPassport = (idOrCode) => readCache().find((x) => x.id === idOrCode || x.code === String(idOrCode).toUpperCase());

export const readQueue = () => { try { return JSON.parse(localStorage.getItem(QUEUE) || "[]"); } catch { return []; } };
export const enqueueRating = (r) => localStorage.setItem(QUEUE, JSON.stringify([...readQueue(), { ...r, queued_at: new Date().toISOString() }]));
export const writeQueue = (q) => localStorage.setItem(QUEUE, JSON.stringify(q));

export const parseScan = (text) => {
  const m = String(text).trim().match(/\/quality\/([0-9a-f-]{36})/i) || String(text).trim().match(/^([0-9a-f-]{36})$/i) || String(text).trim().match(/(QS-[0-9A-F]{8})/i);
  return m ? m[1] : null;
};

export const sha256Hex = async (text) => {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return "0x" + Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const HUBS = [["", "—"], ["taskopru", "Taşköprü farm gate"], ["kastamonu", "Kastamonu centre"], ["inebolu", "İnebolu / coast"], ["ankara", "Ankara dry-goods club"]];
export const getHub = () => localStorage.getItem("qs_hub") || "";
export const setHub = (h) => localStorage.setItem("qs_hub", h);
